if (!customElements.get('mundo-led-discovery')) {
  customElements.define('mundo-led-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const comparison = this.querySelector('.mlai__comparison');
      const range = this.querySelector('.mlai__compare-range');
      range?.addEventListener('input', () => {
        comparison.style.setProperty('--reveal', range.value + '%');
      }, options);
      const buttons = [...this.querySelectorAll('[data-tone-option]')];
      buttons.forEach(button => button.addEventListener('click', () => {
        this.dataset.tone = button.dataset.toneOption;
        this.querySelectorAll("[data-tone-image]").forEach(image => {
          const active = image.dataset.toneImage === button.dataset.toneOption;
          image.classList.toggle("is-active", active);
          image.setAttribute("aria-hidden", String(!active));
        });
        buttons.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
        this.querySelector('[data-tone-badge]').textContent = button.dataset.label;
        this.querySelector('[data-tone-description]').textContent = button.dataset.description;
      }, options));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

